import { render, staticRenderFns } from "./team-allocation-icon.vue?vue&type=template&id=a99fb8d8"
import script from "./team-allocation-icon.vue?vue&type=script&lang=js"
export * from "./team-allocation-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports